import { Collapse } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#cookie-banner')) {
    if (window.localStorage['ArdentCUCookieBanner'] != 'accept') {
      Collapse.getOrCreateInstance(document.querySelector('#cookie-banner')).show();
    }
    document.querySelector('#cookie-banner-dismiss').addEventListener('click', () => {
      window.localStorage['ArdentCUCookieBanner'] = 'accept';
    })
  }
})